<div class="toolbar" fxLayout="row" fxLayoutAlign="space-between">
  <div fxLayout="row" fxLayoutAlign="start center">
    <app-toolbar-sidenav-mobile-toggle (openSidenav)="openSidenav.emit()"></app-toolbar-sidenav-mobile-toggle>

    <div [fxShow.gt-sm]="topNavigation$ | async" 
         [fxShow.xs]="false" 
         [routerLink]="['/']" class="toolbar-logo" fxShow>
      <h3>Nitro Console</h3>
    </div>

    <!-- <div [routerLink]="['/']" class="toolbar-logo" fxShow>
      <h3>Nitro Console</h3>
    </div> -->

    
  </div>

  <div fxLayout="row">

    <app-toolbar-fullscreen-toggle class="toolbar-button"></app-toolbar-fullscreen-toggle>

    <app-toolbar-search fxHide fxShow.gt-sm fxHide.gt-md class="toolbar-button"></app-toolbar-search>

    <app-toolbar-user class="toolbar-button"></app-toolbar-user>
    
  </div>
</div>
